import { AreaItem } from '@/types/cms/AreaItem'
import { Icon } from '@/components/Icon'
import React from 'react'
import { clsx } from 'clsx'
import styles from './TypeVisualizer.module.scss'

const TypeVisualizer = ({
  item,
  position = 'bottom-right',
  className,
}: {
  item: AreaItem
  position?: 'top-left' | 'bottom-right'
  className?: string
}) => {
  const durationFormat = (durationMillis: number) => {
    const minutes = Math.floor(durationMillis / 60000)
    const seconds = Math.floor((durationMillis % 60000) / 1000)
    return `${minutes}:${String(seconds).padStart(2, '0')}`
  }

  return (
    <>
      {item.type === 'video' && (
        <div className={clsx(styles['video-container'], styles[position], className)}>
          <Icon name="play" size={24} />
          {item.model.durationMillis && (
            <span className={styles['video-duration']}>{durationFormat(item.model.durationMillis)}</span>
          )}
        </div>
      )}
      {item.type === 'gallery' && (
        <div className={clsx(styles['gallery-container'], styles[position], className)}>
          <Icon name="gallery" size={24} />
          {item.model.galImgCount && <span className={styles['gallery-count']}>{item.model.galImgCount ?? 0}</span>}
        </div>
      )}
    </>
  )
}

export default TypeVisualizer
